<div class="p-6 py-7 w-full h-full flex flex-col">
  <!-- <button type="button" class="bg-red-500 text-white p-3 mb-2" (click)="show()">show</button> -->

  <div
    class="flex items-center justify-between mb-6"
    *ngIf="!responsibleRegistration && !externalEdit"
  >
    <p class="text-2xl font-bold text-sigecom-dark-gray">Usuários</p>
    <div class="flex items-center gap-2">
      <sigecom-button
        title="USUÁRIOS"
        icon="list"
        (buttonClicked)="navigateToUserList()"
      />
    </div>
  </div>

  <!-- {{ userForm.controls.basicData.getRawValue() | json }} -->
  <!-- <pre>{{ userForm.controls.attachments.getRawValue() | json }}</pre> -->

  <div
    class="bg-white rounded-md"
    [ngClass]="{
      'shadow-md p-4 px-5': !responsibleRegistration && !externalEdit,
      '': responsibleRegistration && externalEdit,
    }"
  >
    <div class="relative">
      <button
        type="button"
        *ngIf="!externalEdit && !othersValidators"
        class="absolute right-3 top-2 flex items-center gap-2 text-sigecom-info text-xs underline"
        title="Outros validadores"
        (click)="othersValidators = !othersValidators"
      >
        <p *ngIf="!othersValidators">Cadastrar outros usuários</p>
        <p *ngIf="othersValidators">Cadastrar usuário para um evento</p>
        <!-- <fa-icon icon="pen"/> -->
      </button>

      <sigecom-box-info
        [attentionText]="''"
        *ngIf="!externalEdit && !othersValidators"
      >
        <div class="relative w-full">
          <div class="flex flex-col items-start gap-2 mb-5">
            <h2 class="font-semibold text-sigecom-dark-gray">
              Selecione o evento o qual o usuário vai ser inscrito:&nbsp;
            </h2>

            <sigecom-new-dropdown
              withShadow
              smallInput
              class="w-[24rem]"
              [options]="eventsOptions?.content || []"
              optionLabel="eveTxNome"
              optionIdentify="eveNrId"
              [formControl]="eventControl"
              paged
              [currentPage]="eventsOptions?.number || 0"
              [totalPages]="eventsOptions?.totalPages || 0"
              (pageChange)="changeEventPage($event)"
              searchble
              (searchChange)="searchEvent($event)"
              [lastValidSelectedOption]="selectedEvent"
            />
          </div>
          <div
            class="flex flex-col items-start gap-2"
            *ngIf="eventUserValidators"
          >
            <h2 class="font-semibold text-sigecom-dark-gray">
              Selecione o papel que o usuário desempenhará no evento:&nbsp;
            </h2>

            <sigecom-new-dropdown
              withShadow
              smallInput
              class="w-[24rem]"
              [options]="userValidationPageOptions"
              optionLabel="label"
              optionIdentify="value"
              [formControl]="userValidationControl"
              searchble
              (searchChange)="searchUserValidation($event)"
              [lastValidSelectedOption]="selectedUserValidation"
            />
            <!-- paged
              [currentPage]="userValidationCurrentPage"
              [totalPages]="userValidationTotalPages"
              (pageChange)="changeUserValidationPage($event)" -->
          </div>
        </div>
      </sigecom-box-info>

      <ng-container *ngIf="othersValidators">
        <div class="flex flex-col gap-2 mb-4">
          <!--
            esse if foi retirado da div de cima
            *ngIf="userValidators?.length! > 0"
            -->
          <h2 class="font-semibold text-sigecom-dark-gray">
            Selecione o tipo de usuário que deseja cadastrar:&nbsp;
          </h2>

          <sigecom-new-dropdown
            label="Validador"
            paged
            [options]="userValidators.content || []"
            optionIdentify="uvcNrId"
            optionLabel="uvcTxNome"
            (changeOption)="changeUserValidator($event)"
            searchble
            [lastValidSelectedOption]="selectedUserValidator"
            [totalPages]="userValidators.totalPages || 1"
            [currentPage]="userValidators.number || 0"
            (pageChange)="loadValidatorsPaged($event)"
            (searchChange)="searchValidator($event)"
          />
        </div>
      </ng-container>
    </div>

    <div class="my-10"></div>

    <form [formGroup]="userForm" appPreventEnterSubmit>
      <sigecom-stepper
        [(currentStep)]="currentStep"
        [disabledSteps]="disabledSteps"
      >
        <!-- USER -->
        <sigecom-step icon="user">
          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Cadastrar dados básicos
          </p>

          <!-- {{ userForm.controls.basicData.value | json }} -->

          <div
            class="grid grid-cols-3 gap-x-3 gap-y-3"
            formGroupName="basicData"
          >
            <div
              class="col-span-full text-sigecom-dark-gray"
              *ngIf="
                selectedUserValidator?.uvcListCampos?.includes(
                  UserBasicDataEnum.AUXILIO_BRASIL
                )
              "
            >
              <p>Pais recebem Bolsa Família?</p>
              <div class="flex gap-2 items-center mt-1">
                <label class="space-x-1">
                  <input
                    type="radio"
                    name="usuBlAuxilioBrasil"
                    formControlName="usuBlAuxilioBrasil"
                    required
                    [value]="true"
                  />
                  Sim
                </label>
                <label class="space-x-1 has-ml-20">
                  <input
                    type="radio"
                    name="usuBlAuxilioBrasil"
                    formControlName="usuBlAuxilioBrasil"
                    required
                    [value]="false"
                  />
                  Não
                </label>
              </div>
            </div>

            <sigecom-input-container
              enableRequiredBorder
              label="Nome completo"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.basicData, 'usuTxNome')
              "
            >
              <input
                sigecom-input
                blockNumbers
                type="text"
                placeholder="Ex.: José Alessando dos Santos Santana"
                name="usuTxNome"
                formControlName="usuTxNome"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Sexo atribuído ao nascimento"
              [type]="InputTypeEnum.SELECT"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.basicData, 'usuTxSexo')
              "
            >
              <select
                sigecom-input
                name="usuTxSexo"
                formControlName="usuTxSexo"
              >
                <option [ngValue]="null" selected>Selecione...</option>
                <option
                  *ngFor="let type of SexoEnum | keyvalue"
                  [value]="type.value"
                >
                  {{ type.key }}
                </option>
              </select>
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Data de nascimento"
              [errorMessage]="
                fieldErrorMessage(
                  userForm.controls.basicData,
                  'usuDtNascimento'
                )
              "
            >
              <input
                sigecom-input
                birthdate
                type="date"
                name="usuDtNascimento"
                onchange="verifyDate()"
                formControlName="usuDtNascimento"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Tipo sanguíneo"
              [type]="InputTypeEnum.SELECT"
              [errorMessage]="
                fieldErrorMessage(
                  userForm.controls.basicData,
                  'usuTxTipoSanguineo'
                )
              "
            >
              <select
                sigecom-input
                name="usuTxTipoSanguineo"
                formControlName="usuTxTipoSanguineo"
              >
                <option [ngValue]="null" selected>Selecione...</option>
                <option
                  *ngFor="let type of BloodTypeEnum | keyvalue"
                  [value]="type.value"
                >
                  {{ type.key }}
                </option>
              </select>
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Lado dominante"
              [type]="InputTypeEnum.SELECT"
              [errorMessage]="
                fieldErrorMessage(
                  userForm.controls.basicData,
                  'usuTxLadoDominante'
                )
              "
            >
              <select
                sigecom-input
                name="usuTxLadoDominante"
                formControlName="usuTxLadoDominante"
              >
                <option [ngValue]="null" selected>Selecione...</option>
                <option
                  *ngFor="let type of DominantHandEnum | keyvalue"
                  [value]="type.value"
                >
                  {{ type.key }}
                </option>
              </select>
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Peso atual (kg)"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.basicData, 'usuNrPeso')
              "
            >
              <input
                sigecom-input
                type="text"
                mask="00.00||000.00"
                [showMaskTyped]="true"
                [allowNegativeNumbers]="false"
                placeHolderCharacter="-"
                [dropSpecialCharacters]="false"
                name="usuNrPeso"
                formControlName="usuNrPeso"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Altura atual (metros)"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.basicData, 'usuNrAltura')
              "
            >
              <input
                sigecom-input
                type="text"
                mask="0.00"
                [showMaskTyped]="true"
                placeHolderCharacter="-"
                [allowNegativeNumbers]="false"
                [dropSpecialCharacters]="false"
                name="usuNrAltura"
                formControlName="usuNrAltura"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Código INEP do atleta"
              [errorMessage]="
                fieldErrorMessage(
                  userForm.controls.basicData,
                  'usuTxCodigoInep'
                )
              "
            >
              <input
                sigecom-input
                type="text"
                minlength="12"
                maxlength="12"
                mask="000000000000"
                placeholder="Ex.: 123456789101"
                name="usuTxCodigoInep"
                formControlName="usuTxCodigoInep"
              />
            </sigecom-input-container>

            <!-- ADITIONAL DATA -->

            <p
              class="col-span-full text-xl font-semibold text-sigecom-dark-gray block"
            >
              Dados adicionais
            </p>

            <div class="col-span-full">
              <sigecom-box-info [attentionText]="'Atenção!'">
                <p class="mb-4">
                  Ao associar o usuário a uma federação a uma instituição, você
                  estará definindo um limite de acesso a este usuário. Usuários
                  associados a uma federação, só estão acessíveis para usuários
                  da mesma federação e que possuam algum cargo representativo na
                  mesma. Da semelhante forma, usuários associados a uma
                  instituição, só estão acessíveis para outros usuários da mesma
                  instituição e que possuam um cargo representativo na mesma.
                </p>
                <p class="mb-4">
                  Usuários que possuam cargo representativo em uma federação,
                  tem acesso a todos os usuários desta federação, incluindo os
                  usuários das instituições que compõem a federação
                </p>
              </sigecom-box-info>
            </div>

            <div
              class="col-span-full"
              [ngClass]="{ hidden: !isFederationVisible }"
            >
              <sigecom-new-dropdown
                label="Federação"
                paged
                searchble
                [options]="federationOptions?.content || []"
                optionIdentify="fedNrId"
                optionLabel="fedTxNome"
                formControlName="fedNrId"
                [lastValidSelectedOption]="selectedFederation"
                [totalPages]="federationOptions?.totalPages || 1"
                [currentPage]="federationOptions?.number || 0"
                (pageChange)="loadFederationsPaged($event)"
                (searchChange)="searchFederationsByName($event)"
                [error]="
                  fieldErrorMessage(userForm.controls.basicData, 'fedNrId')
                "
              />
            </div>

            <div class="col-span-full" *ngIf="isInstitutionVisible">
              <h4 class="mb-1">Instituição de ensino do usuário</h4>
              <sigecom-select-search-container
                [inputContainerShow]="true"
                [isRequired]="insNrId.validator != null"
                [enableRequiredBorder]="insNrId.validator != null"
                label="Pesquise a instituição de ensino"
                labelSearch="Nome da instituicao"
                (searchEmmit)="changeSearchInstitutions($event)"
                [errorMessage]="
                  fieldErrorMessage(userForm.controls.basicData, 'insNrId')
                "
                [isDisabled]="!userForm.controls.basicData.controls.fedNrId"
              >
                <sigecom-input-container
                  extra-filters
                  class="w-2/3"
                  label="CNPJ"
                >
                  <input
                    extra-filters
                    sigecom-input
                    #cnpjInput
                    type="text"
                    mask="00.000.000/0000-00"
                    placeholder="Ex.: 00.000.000/0000-00"
                    (debouncedInput)="findInstituicaoPorCnpj(cnpjInput.value)"
                    (keyup.enter)="findInstituicaoPorCnpj(cnpjInput.value)"
                  />
                </sigecom-input-container>

                <sigecom-input-container
                  extra-filters
                  class="w-2/3"
                  label="INEP"
                >
                  <input
                    extra-filters
                    sigecom-input
                    #inepInput
                    type="text"
                    placeholder="Informe o INEP"
                    (debouncedInput)="findInstituicaoPorInep(inepInput.value)"
                    (keyup.enter)="findInstituicaoPorInep(inepInput.value)"
                  />
                </sigecom-input-container>

                <select class="h-56" name="insNrId" formControlName="insNrId">
                  <option [ngValue]="null" selected>Selecione...</option>
                  <option
                    *ngFor="
                      let teachingInstitution of institutionsOptions?.content!
                    "
                    [ngValue]="teachingInstitution?.insNrId"
                  >
                    {{ teachingInstitution?.insTxNome }}
                  </option>
                </select>

                <div
                  class="mt-4"
                  *ngIf="institutionsOptions?.content?.length! > 0"
                >
                  <sigecom-pagination-list
                    [totalPages]="institutionsOptions?.totalPages!"
                    [maxDisplayedPages]="maxDisplayedPages"
                    (pageChange)="onPageChange($event)"
                  />
                </div>
              </sigecom-select-search-container>
            </div>

            <div class="col-span-full">
              <sigecom-selected-card
                label="Instituição selecionada"
                [value]="selectedUserInstitution?.insTxNome"
                emptyMessage="Selecione uma instituição."
                [removable]="showRemoveInstitutionButton"
                (remove)="removeInstitution()"
              />
            </div>

            <div class="col-span-full">
              <sigecom-box-info [attentionText]="'Atenção!'">
                <p>
                  Ao atribuir um cargo a um usuário você estará concedendo
                  acesso ao sistema para este usuário. Após realizar o cadastro,
                  o usuário receberá seu login e senha de acesso via e-mail
                  cadastrado.
                </p>
              </sigecom-box-info>
            </div>

            <div class="col-span-full" *ngIf="isPositionVisible">
              <sigecom-input-container
                enableRequiredBorder
                label="Cargo"
                [type]="InputTypeEnum.SELECT"
                [errorMessage]="fieldErrorMessage(userForm, 'carNrId')"
              >
                <select sigecom-input name="carNrId" formControlName="carNrId">
                  <option [ngValue]="null" selected>Selecione...</option>
                  <option
                    *ngFor="let position of positionsOptions?.content"
                    [value]="position.carNrId"
                  >
                    {{ position.carTxDescricao }}
                  </option>
                </select>
              </sigecom-input-container>

              <sigecom-button
                class="mt-2"
                *ngIf="temCargoEspecifico()"
                type="info"
                [outlined]="true"
                title="Gerar Nova Senha"
                icon="key"
                (click)="generateNewPassword()"
              >
              </sigecom-button>
            </div>
          </div>

          <!-- RESPONSIBLES -->
          <ng-container
            *ngIf="
              !responsibleRegistration &&
              (requiredResponsible || userForm.controls.responsibles.length > 0)
            "
          >
            <div class="mt-6">
              <p
                class="text-xl font-semibold text-sigecom-dark-gray block mb-3"
              >
                Responsáveis
              </p>

              <div class="flex items-center gap-2">
                <div
                  class="border border-[#dadada] h-9 items-center rounded-md w-[20rem]"
                >
                  <select
                    sigecom-input
                    name="ureTxParentesco"
                    class="px-3 py-1 h-9 items-center w-full"
                    [formControl]="selectDocumentControl"
                  >
                    <option [ngValue]="null" selected>Selecione...</option>
                    <option
                      *ngFor="let type of DocumentTypeEnum | keyvalue"
                      [ngValue]="type.value"
                    >
                      {{ type.key }}
                    </option>
                  </select>
                </div>
                <div class="w-full relative">
                  <div class="flex items-center gap-2">
                    <input
                      type="text"
                      placeholder="Buscar por CPF ou RG..."
                      [formControl]="searchResponsibleControl"
                      class="w-full h-9 border border-[#dadada] rounded-md relative pl-2 outline-none focus:ring-1 focus:ring-sigecom-info"
                    />
                  </div>
                  <fa-icon
                    [icon]="'magnifying-glass'"
                    class="absolute right-2 text-sigecom-dark-gray top-2"
                  ></fa-icon>
                </div>
                <button
                  type="button"
                  class="rounded-md px-3 py-1.5 gap-2 text-white border border-sigecom-info bg-sigecom-info flex items-center justify-center disabled:opacity-40"
                  (click)="showResponsibleModal()"
                  [disabled]="
                    isModal || userForm.controls.responsibles.length === 3
                  "
                >
                  <p class="font-medium">Novo</p>
                  <fa-icon icon="add"></fa-icon>
                </button>
              </div>

              <sigecom-modal
                #resModal
                [open]="responsibleRegistrationModalVisible"
                (modalStateChange)="changeModalState($event)"
              >
                <div
                  class="w-[60rem]"
                  *ngIf="responsibleRegistrationModalVisible"
                >
                  <sigecom-user-form
                    [responsibleRegistration]="true"
                    (saveResponsibleEmit)="responsibleAdd($event)"
                    (cancelResponsibleEmit)="closeResponsibleModal()"
                    [addressFg]="userForm.controls.address"
                    [usuNrId]="responsibleEditId"
                    [eventForResponsibleValidation]="
                      selectedEventForResponsibleValidation
                    "
                    [responsibleValidation]="
                      selectedValidationForResponsibleValidation
                    "
                  />
                </div>
              </sigecom-modal>

              <!-- LIST RESPONSIBLES -->

              <div class="flex flex-col gap-3 mt-4">
                <ng-container
                  *ngIf="userForm.controls.responsibles.controls.length === 0"
                >
                  <p class="text-center my-5 mb-7">
                    Realize o cadastro de um responsável ou pesquise por um já
                    cadastrado no campo de busca acima.
                  </p>
                </ng-container>

                <div
                  *ngFor="
                    let responsibleFg of userForm.controls.responsibles
                      .controls;
                    let i = index
                  "
                  class="flex gap-2 items-center"
                >
                  <ng-container [formGroup]="responsibleFg">
                    <div
                      class="px-4 py-2.5 pb-3 rounded-md flex flex-col border border-sigecom-outlined-gray flex-1"
                    >
                      <p class="text-sigecom-dark-gray font-bold text-sm mb-2">
                        Responsável
                      </p>
                      <p>{{ responsibleFg.controls.usuTxNome.value }}</p>
                    </div>

                    <div class="w-[30%]">
                      <sigecom-input-container
                        enableRequiredBorder
                        label="Tipo de responsável"
                        [type]="InputTypeEnum.SELECT"
                        [errorMessage]="
                          fieldErrorMessage(responsibleFg, 'ureTxParentesco')
                        "
                      >
                        <select
                          sigecom-input
                          name="ureTxParentesco"
                          formControlName="ureTxParentesco"
                        >
                          <option [ngValue]="null" selected>
                            Selecione...
                          </option>
                          <option
                            *ngFor="
                              let type of DegreeOfRelationshipEnum | keyvalue
                            "
                            [ngValue]="type.value"
                          >
                            {{ type.key }}
                          </option>
                        </select>
                      </sigecom-input-container>
                    </div>

                    <div
                      class="p-4 py-2.5 h-[4.85rem] border border-sigecom-dark-gray bg-white rounded-md flex flex-col gap-2 items-center justify-center"
                    >
                      <button
                        type="button"
                        (click)="removeSelectedResponsible(i)"
                      >
                        <fa-icon
                          icon="trash"
                          class="text-sigecom-danger"
                        ></fa-icon>
                      </button>
                      <button
                        type="button"
                        (click)="editResponsibleSelected(i)"
                        [disabled]="isModal"
                        class="disabled:opacity-40"
                      >
                        <fa-icon
                          icon="pen"
                          class="text-sigecom-info text-sm"
                        ></fa-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </sigecom-step>

        <!-- ADDRESS -->
        <sigecom-step icon="house">
          <!-- <div>{{ userForm.controls.address.value | json }}</div> -->

          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Cadastrar endereço
          </p>

          <ng-container *ngIf="responsibleRegistration">
            <div class="mb-4">
              <div class="flex gap-2 items-center">
                <input
                  type="checkbox"
                  [formControl]="liveInTheSameHouse"
                  (change)="putUserAdressToGuardian($event)"
                  name="checkPullAddress"
                />
                Reside na mesma casa do usuário pelo qual será responsável?
              </div>
            </div>
          </ng-container>

          <div class="grid grid-cols-3 gap-x-3 gap-y-3" formGroupName="address">
            <sigecom-input-container
              enableRequiredBorder
              label="CEP"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.address, 'logTxCep')
              "
            >
              <input
                sigecom-input
                name="logTxCep"
                type="text"
                mask="00000-000"
                (keyup)="searchLogradouroByCep(logTxCep)"
                placeholder="Ex.: 20211-901"
                formControlName="logTxCep"
                #logTxCep
              />
            </sigecom-input-container>

            <sigecom-new-dropdown
              label="País"
              formControlName="paiNrId"
              [options]="countryOptions?.content ?? []"
              optionLabel="paiTxDescricaoPt"
              optionIdentify="paiNrId"
              [lastValidSelectedOption]="selectedCountry"
              [error]="fieldErrorMessage(userForm.controls.address, 'paiNrId')"
              paged
              (pageChange)="loadCountriesPaged($event)"
              [currentPage]="countryOptions?.number ?? 0"
              [totalPages]="countryOptions?.totalPages ?? 1"
              searchble
              (searchChange)="searchCountries($event)"
            />

            <sigecom-new-dropdown
              label="Estado"
              formControlName="estNrId"
              [options]="statesOptions?.content ?? []"
              optionLabel="estTxDescricao"
              optionIdentify="estNrId"
              [lastValidSelectedOption]="selectedState"
              [error]="fieldErrorMessage(userForm.controls.address, 'estNrId')"
              paged
              (pageChange)="loadStatesPaged($event)"
              [currentPage]="statesOptions?.number ?? 0"
              [totalPages]="statesOptions?.totalPages ?? 1"
              searchble
              (searchChange)="searchStates($event)"
            />

            <sigecom-new-dropdown
              label="Município"
              formControlName="cidNrId"
              [options]="cityOptions?.content ?? []"
              optionLabel="cidTxDescricao"
              optionIdentify="cidNrId"
              [lastValidSelectedOption]="selectedCity"
              [error]="fieldErrorMessage(userForm.controls.address, 'cidNrId')"
              paged
              (pageChange)="loadCitiesPaged($event)"
              [currentPage]="cityOptions?.number ?? 0"
              [totalPages]="cityOptions?.totalPages ?? 1"
              searchble
              (searchChange)="searchCities($event)"
            />

            <sigecom-input-container
              enableRequiredBorder
              label="Logradouro"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.address, 'logTxLogradouro')
              "
            >
              <input
                sigecom-input
                type="text"
                placeholder="Ex.: Ladeira do Castro"
                name="logTxLogradouro"
                formControlName="logTxLogradouro"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Número"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.address, 'logNrNumero')
              "
            >
              <input
                sigecom-input
                type="number"
                placeholder="Ex.: 999"
                name="logNrNumero"
                formControlName="logNrNumero"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Bairro"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.address, 'logTxBairro')
              "
            >
              <input
                sigecom-input
                type="text"
                placeholder="Ex.: Santa Teresa"
                name="logTxBairro"
                formControlName="logTxBairro"
              />
            </sigecom-input-container>

            <sigecom-input-container
              enableRequiredBorder
              label="Complemento"
              [errorMessage]="
                fieldErrorMessage(userForm.controls.address, 'logTxComplemento')
              "
            >
              <input
                sigecom-input
                type="text"
                placeholder="Ex.: Apartamento"
                name="logTxComplemento"
                formControlName="logTxComplemento"
              />
            </sigecom-input-container>
          </div>
        </sigecom-step>

        <!-- CONTATO -->
        <sigecom-step icon="phone">
          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Dados de contato
          </p>

          <div formArrayName="contacts">
            <div
              class="flex flex-wrap w-full gap-2 mb-2"
              *ngFor="
                let contatoFg of userForm.controls.contacts.controls;
                let i = index
              "
            >
              <!-- {{ contatoFg.value | json }} -->
              <ng-container [formGroup]="contatoFg">
                <div class="w-[50%]">
                  <sigecom-input-container
                    enableRequiredBorder
                    label="Contato"
                    [errorMessage]="
                      getContactErrorMessage(contatoFg.controls) ??
                      fieldErrorMessage(
                        contatoFg,
                        'conTxContato',
                        contatoFg.controls.conTxTipo.value
                      )
                    "
                    [isLoading]="
                      contatoFg.controls.conTxTipo.value ===
                      ContactTypeEnum.Telefone
                        ? loadingPhoneValidation
                        : contatoFg.controls.conTxTipo.value ===
                            ContactTypeEnum.Email
                          ? loadingEmailValidation
                          : false
                    "
                    [isDisabled]="contatoFg.controls.conTxTipo.value === null"
                  >
                    <ng-template
                      [ngIf]="
                        contatoFg.controls.conTxTipo.value ===
                        ContactTypeEnum.Telefone
                      "
                    >
                      <input
                        sigecom-input
                        (debouncedInput)="
                          userForm.controls.contacts.updateValueAndValidity()
                        "
                        formControlName="conTxContato"
                        type="text"
                        placeholder="Ex.: (99) 9 9999-9999"
                        mask="(00) 0 0000-0000"
                      />
                    </ng-template>
                    <ng-template
                      [ngIf]="
                        contatoFg.controls.conTxTipo.value ===
                        ContactTypeEnum.Email
                      "
                    >
                      <input
                        sigecom-input
                        (debouncedInput)="
                          userForm.controls.contacts.updateValueAndValidity()
                        "
                        autocomplete="email"
                        formControlName="conTxContato"
                        type="email"
                        [pattern]="regex.email"
                        placeholder="Ex.: email@exemplo.com"
                        email
                      />
                    </ng-template>
                    <ng-template
                      [ngIf]="
                        contatoFg.controls.conTxTipo.value ===
                        ContactTypeEnum.Site
                      "
                    >
                      <input
                        sigecom-input
                        (debouncedInput)="
                          userForm.controls.contacts.updateValueAndValidity()
                        "
                        formControlName="conTxContato"
                        type="text"
                        placeholder="Ex.: www.exemplo.com"
                      />
                    </ng-template>
                    <ng-template
                      [ngIf]="contatoFg.controls.conTxTipo.value === null"
                    >
                      <input
                        sigecom-input
                        (debouncedInput)="
                          userForm.controls.contacts.updateValueAndValidity()
                        "
                        formControlName="conTxContato"
                        type="text"
                        placeholder="Selecione um tipo de contato..."
                      />
                    </ng-template>
                  </sigecom-input-container>
                </div>

                <div class="flex-1">
                  <sigecom-input-container
                    enableRequiredBorder
                    label="Tipo do contato"
                    [type]="InputTypeEnum.SELECT"
                    [isDisabled]="contatoFg.controls.conBlPrincipal.value!"
                    [errorMessage]="fieldErrorMessage(contatoFg, 'conTxTipo')"
                  >
                    <select sigecom-input formControlName="conTxTipo">
                      <option [ngValue]="null">Selecione...</option>
                      <option
                        *ngFor="let type of ContactTypeEnum | keyvalue"
                        [value]="type.value"
                      >
                        {{ type.key }}
                      </option>
                    </select>
                  </sigecom-input-container>
                </div>
              </ng-container>

              <div
                class="col-auto w-10"
                *ngIf="!contatoFg.controls.conBlPrincipal.value"
              >
                <sigecom-button
                  icon="xmark"
                  class="h-full"
                  (buttonClicked)="removeContact(i)"
                />
              </div>
            </div>

            <div class="col-span-full">
              <sigecom-button
                title="ADICIONAR"
                icon="plus"
                type="info"
                [outlined]="true"
                (buttonClicked)="addContact()"
              />
            </div>
          </div>
        </sigecom-step>

        <!-- DADOS BANCARIOS -->
        <sigecom-step *ngIf="showBankForm" icon="sack-dollar">
          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Dados Bancários
          </p>
          <form
            formGroupName="contaBancariaForm"
            class="grid gap-2 grid-cols-2"
          >
            <div class="flex gap-2 w-full">
              <sigecom-new-dropdown
                class="flex-1"
                [options]="bankList?.content || []"
                optionLabel="banTxNome"
                optionIdentify="banNrId"
                label="Banco"
                formControlName="banNrId"
                paged
                (pageChange)="changeBancoPage($event)"
                [currentPage]="bankList?.number || 0"
                [totalPages]="bankList?.totalPages || 0"
                searchble
                (searchChange)="searchBanco($event)"
                [lastValidSelectedOption]="selectedBanco"
                [enableRequiredBorder]="true"
                [error]="
                  fieldErrorMessage(
                    userForm.controls.contaBancariaForm,
                    'banNrId'
                  )
                "
              />

              <sigecom-input-container [label]="'Código'" class="w-24 shrink-0">
                <input
                  sigecom-input
                  type="text"
                  readonly
                  class="bg-gray-100 cursor-not-allowed text-center"
                  [value]="currentBankCod || ''"
                />
              </sigecom-input-container>
            </div>
            <sigecom-new-dropdown
              [enableRequiredBorder]="true"
              [options]="agenciaPage?.content || []"
              optionLabel="ageTxCodigo"
              optionIdentify="ageNrId"
              label="Agência"
              formControlName="ageNrId"
              paged
              [currentPage]="agenciaPage?.number || 0"
              [totalPages]="agenciaPage?.totalPages || 0"
              (pageChange)="changeAgenciaPage($event)"
              searchble
              (searchChange)="searchAgencia($event)"
              [lastValidSelectedOption]="selectedAgencia"
              [error]="
                fieldErrorMessage(
                  userForm.controls.contaBancariaForm,
                  'ageTxCodigo'
                )
              "
            />
            <sigecom-input-container
              enableRequiredBorder
              [label]="'Número da conta'"
              [errorMessage]="
                fieldErrorMessage(
                  userForm.controls.contaBancariaForm,
                  'cobTxNumeroConta'
                )
              "
            >
              <input
                sigecom-input
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                mask="00000000-0"
                [placeholder]="'Ex: 12039929012-2'"
                formControlName="cobTxNumeroConta"
              />
            </sigecom-input-container>
            <sigecom-new-dropdown
              [label]="'Tipo da conta'"
              [options]="tipoContaOptions"
              optionIdentify="value"
              optionLabel="label"
              formControlName="cobTxTipoConta"
              [enableRequiredBorder]="true"
              [error]="
                fieldErrorMessage(
                  userForm.controls.contaBancariaForm,
                  'cobTxTipoConta'
                )
              "
            />
          </form>
        </sigecom-step>

        <!-- DOCUMENTO -->
        <sigecom-step icon="file">
          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Documentos
          </p>

          <div
            class="flex flex-col justify-start gap-4"
            formArrayName="documents"
          >
            <div
              *ngFor="
                let documentFg of userForm.controls.documents.controls;
                let i = index
              "
            >
              <div
                [formGroup]="documentFg"
                class="flex items-center gap-2 col-span-full"
              >
                <div class="flex-1">
                  <sigecom-input-container
                    enableRequiredBorder
                    [label]="documentFg.controls.label.value ?? 'Documento'"
                    [errorMessage]="
                      getCpfErrorMessage(documentFg.controls.docTxTipo.value) ??
                      fieldErrorMessage(
                        documentFg,
                        'docTxDocumento',
                        documentFg.controls.docTxTipo.value
                      )
                    "
                    [isLoading]="
                      documentFg.controls.docTxTipo.value ===
                        DocumentTypeEnum.CPF && cpfValidationLoading
                    "
                  >
                    <input
                      sigecom-input
                      type="text"
                      [mask]="documentFg.controls.mask.value"
                      [placeholder]="documentFg.controls.placeholder.value"
                      formControlName="docTxDocumento"
                      (debouncedInput)="
                        userForm.controls.documents.updateValueAndValidity();
                        documentFg.controls.docTxDocumento.updateValueAndValidity();
                        checkCrefStatus()
                      "
                    />
                  </sigecom-input-container>
                </div>
                <div
                  class="flex-1"
                  *ngIf="
                    documentFg.controls.docTxTipo.value === DocumentTypeEnum.RG
                  "
                >
                  <sigecom-input-container
                    enableRequiredBorder
                    label="Órgão expedidor {{
                      documentFg?.controls?.label?.value
                    }}"
                    [errorMessage]="
                      fieldErrorMessage(documentFg, 'docTxOrgaoExpeditor')
                    "
                  >
                    <input
                      sigecom-input
                      type="text"
                      placeholder="Secretaria de segurança pública"
                      formControlName="docTxOrgaoExpeditor"
                      (input)="
                        sanitizeLettersOnly(
                          $event,
                          documentFg.controls.docTxOrgaoExpeditor
                        )
                      "
                      (debouncedInput)="
                        userForm.controls.documents.updateValueAndValidity();
                        documentFg.controls.docTxDocumento.updateValueAndValidity()
                      "
                    />
                  </sigecom-input-container>
                </div>
              </div>
            </div>
          </div>
        </sigecom-step>

        <!-- ANEXOS -->
        <sigecom-step icon="paperclip">
          <p class="text-xl font-semibold text-sigecom-dark-gray block mb-3">
            Anexos
          </p>

          <div
            class="grid grid-cols-2 gap-x-4 gap-y-4"
            formArrayName="attachments"
          >
            <div class="col-span-full">
              <ng-container *ngIf="filteredAttachments.length > 0">
                <div
                  class="border border-sigecom-outlined-gray text-sigecom-outlined-gray px-3 py-3.5 rounded-md"
                >
                  <p class="font-bold text-sm mb-2 px-1.5">Adicionar anexos</p>

                  <div class="max-h-[12rem] overflow-y-auto">
                    <ng-container
                      *ngFor="let attachment of filteredAttachments"
                    >
                      <div
                        class="cursor-pointer font-semibold shadow-flat-xl rounded-md px-3 py-2 m-1 flex items-center justify-between mr-2.5"
                        (click)="onAttachmentAvailableChange(attachment)"
                      >
                        {{ attachment.label }}
                        <fa-icon icon="add" class="text-sigecom-info" />
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>

            <ng-container
              *ngFor="
                let attachmentFg of userForm.controls.attachments.controls;
                let i = index
              "
            >
              <!-- {{ attachmentFg.value | json }} -->
              <ng-container
                *ngIf="
                  attachmentFg.controls.aneTxTipoAnexo.value !==
                  AttachmentTypeEnum.FOTO
                "
                [formGroup]="attachmentFg"
              >
                <div class="relative">
                  <sigecom-file-upload
                    enableRequiredBorder
                    [label]="attachmentFg.controls.label.value ?? 'Anexo {{i}}'"
                    [accepts]="attachmentFg.controls.accepts.value!"
                    [lastBase64]="attachmentFg.controls.aneBtAnexo.value!"
                    [aneNrId]="attachmentFg.controls.aneNrId.value"
                    (base64)="changeBase64($event, attachmentFg)"
                    (format)="changeFormat($event, attachmentFg)"
                    [isRequired]="containsInRequiredAttachments(attachmentFg)"
                    [errorMessage]="
                      fieldErrorMessage(
                        attachmentFg,
                        'aneBtAnexo',
                        attachmentFg.controls.aneTxTipoAnexo.value
                      )
                    "
                  />

                  <ng-container *ngIf="showRemoveAttachmentField(attachmentFg)">
                    <button
                      type="button"
                      class="absolute top-0 right-0 bg-sigecom-danger w-7 h-7 rounded-tr-md rounded-bl-md flex items-center justify-center"
                      (click)="removeAvailableAttachmentAdded(i)"
                    >
                      <fa-icon
                        icon="trash"
                        class="text-white text-xs"
                      ></fa-icon>
                    </button>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>

            <div *ngIf="attachmentFoto" class="col-span-full">
              <div class="flex items-start gap-2 order-last">
                <div class="flex-1 flex flex-col relative">
                  <sigecom-file-upload
                    enableRequiredBorder
                    [label]="
                      attachmentFoto.controls.label.value ?? 'Anexo {{i}}'
                    "
                    [accepts]="attachmentFoto.controls.accepts.value!"
                    [lastBase64]="attachmentFoto.controls.aneBtAnexo.value!"
                    [aneNrId]="attachmentFoto.controls.aneNrId.value"
                    (base64)="photoChange($event, attachmentFoto)"
                    (format)="changeFormat($event, attachmentFoto)"
                    [isRequired]="attachmentFotoIsRequired"
                    [errorMessage]="
                      fieldErrorMessage(
                        attachmentFoto,
                        'aneBtAnexo',
                        attachmentFoto.controls.aneTxTipoAnexo.value
                      )
                    "
                  />
                  <ng-container
                    *ngIf="showRemoveAttachmentField(attachmentFoto)"
                  >
                    <button
                      type="button"
                      class="absolute top-0 right-0 bg-sigecom-danger w-7 h-7 rounded-tr-md rounded-bl-md flex items-center justify-center"
                      (click)="removeAttachmentFoto()"
                    >
                      <fa-icon
                        icon="trash"
                        class="text-white text-xs"
                      ></fa-icon>
                    </button>
                  </ng-container>

                  <p class="py-4">
                    Sua foto será exibida na credencial conforme o exemplo no
                    preview.
                  </p>
                </div>

                <div
                  class="border border-sigecom-outlined-gray text-center rounded-md w-44 aspect-[3/4] flex items-center justify-center overflow-hidden"
                >
                  <ng-container *ngIf="previewPhotoForEditingState">
                    <img
                      *ngIf="previewPhotoForEditingState"
                      [src]="previewPhotoForEditingState"
                      alt="preview da foto"
                      class="w-[100%] h-[100%]"
                    />
                  </ng-container>
                  <ng-container *ngIf="!externalEdit">
                    <ng-container *ngIf="!previewPhotoForEditingState">
                      <img
                        *ngIf="attachmentFoto.controls.aneBtAnexo.value"
                        [src]="attachmentFoto.controls.aneBtAnexo.value"
                        alt="preview da foto"
                        class="w-[100%] h-[100%]"
                      />
                    </ng-container>
                  </ng-container>

                  <p
                    *ngIf="!attachmentFoto.controls.aneBtAnexo.value"
                    class="text-sm"
                  >
                    Insira uma foto para visualizar o preview
                  </p>
                </div>
              </div>
            </div>
          </div>
        </sigecom-step>
      </sigecom-stepper>

      <!-- Termos de uso -->
      <div class="flex gap-2 pl-2 items-center" formGroupName="termoUsoForm">
        <input
          formControlName="usuBlTermoDeUso"
          (change)="setTerm()"
          type="checkbox"
        />
        <p>
          Li e estou de acordo com os
          <button
            class="font-bold text-cbde-primary"
            type="button"
            (click)="openUseTerms()"
          >
            Termos de Uso.
          </button>
        </p>
      </div>

      <!-- <div class="flex items-center gap-2 justify-end">
        <sigecom-button icon="xmark" [outlined]="true" type="danger" title="Cancelar" (buttonClicked)="navigateToUserList()" *ngIf="!externalEdit"/>
        <sigecom-button [submitButton]="true" icon="floppy-disk" [outlined]="true" type="info" title="Salvar" [disabled]="userForm.invalid" />
        <sigecom-button [submitButton]="true" icon="floppy-disk" [outlined]="true" type="info" title="Salvar" />
      </div>

      <sigecom-button (buttonClicked)="printForm()" title="printForm" />
      -->
      <sigecom-action-buttons
        [isSaveDisabled]="
          !!userForm.invalid ||
          cpfControlMessage !== null ||
          phoneControlMessage !== null ||
          emailControlMessage !== null
        "
        (cancelClick)="handleCancelClick()"
        [disableFloating]="isModal"
        (saveClick)="onSubmit()"
        [textInfo]="!isModal ? usuNrId?.toString() : undefined"
      >
      </sigecom-action-buttons>
    </form>
  </div>

  <sigecom-modal
    [open]="openModalUseTerms"
    (modalStateChange)="toggleModalUseTerms($event)"
  >
    <div class="relative mx-2 my-2">
      <h1 class="text-cbde-primary font-bold text-xl pb-2">Termos de uso</h1>

      <p class="text-justify">
        {{ useTerms?.terTxTexto }}
      </p>
    </div>
  </sigecom-modal>

  <sigecom-modal
    [open]="openModalCpfValidation"
    (modalStateChange)="closeModalCpfValidation($event)"
  >
    <div class="relative mx-2 my-2 max-w-2xl">
      <h1 class="text-sigecom-dark-gray2 font-bold text-xl pb-2">
        CPF já cadastrado
      </h1>
      <p class="text-justify">
        O CPF informado pertence a {{ cpfRedirectData?.usuTxNome }} da sua
        federação. Deseja editar este cadastro ou continuar com um novo
        cadastro?
      </p>
      <div class="flex gap-2 mt-4 justify-end">
        <sigecom-button
          title="Continuar novo cadastro"
          outlined
          (buttonClicked)="handleContinueWithNewCpf()"
        />
        <sigecom-button
          title="Editar cadastro"
          type="info"
          (buttonClicked)="handleEditExistingUserWithCpf()"
        />
      </div>
    </div>
  </sigecom-modal>
</div>
